export enum SSO_ActionDispatchTypes {
  SSO_INVOKE = "SSO_INVOKE",
  SSO_SUCCESS = "SSO_SUCCESS",
  SSO_ERROR = "SSO_ERROR",
  SSO_RESET = "SSO_RESET",
}

export enum SSO_Refresh_Token_ActionDispatchTypes {
  SSO_REFRESH_TOKEN_INVOKE = "SSO_REFRESH_TOKEN_INVOKE",
  SSO_REFRESH_TOKEN_SUCCESS = "SSO_REFRESH_TOKEN_SUCCESS",
  SSO_REFRESH_TOKEN_ERROR = "SSO_REFRESH_TOKEN_ERROR",
  SSO_REFRESH_TOKEN_RESET = "SSO_REFRESH_TOKEN_RESET",
}